export default __webpack_public_path__ + "static/media/new6.bdfcb210.jpg";